import React from "react";
import Home from "../../../components/Home/Home";

const ProjectIdeas = () => {
  return (
    <div>
      <Home></Home>
    </div>
  );
};

export default ProjectIdeas;
